<template>
  <div id="app">
    <section class="main">
      <div class="noFooter">
        <app-header></app-header>
        <app-navbar></app-navbar>
        <transition :name="direction" mode="out-in">
          <router-view id="slide" class="slide-left"></router-view>
        </transition>
      </div>
      <app-footer></app-footer>
    </section>
  </div>
</template>

<script>
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default {
  data: function () {
    return {
      direction: "slide-left",
    };
  },
  components: {
    "app-header": Header,
    "app-navbar": Navbar,
    "app-footer": Footer,
  },
};
</script>

<style lang="scss">
* {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
*::-webkit-scrollbar {
  display: none;
}

.noFooter {
  //min-height: 100vh;
  //min-height: calc(100vh - 7.4rem);
}

.main {
  background-image: linear-gradient(
      rgba(17, 15, 47, 0.65),
      rgba(8, 7, 22, 0.65)
    ),
    url(assets/img/polygon.jpg);
  background-attachment: fixed;
  background-position: center;
  background-size: cover;

  font-family: "Raleway", sans-serif;

  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

p {
  line-height: 1.75;
}

.text-faded {
  color: fade-out($white, 0.7);
}

.site-heading {
  margin-top: 5rem;
  margin-bottom: 5rem;
  text-transform: uppercase;
  line-height: 1;

  .site-heading-upper {
    display: block;
    font-size: 2rem;
    font-weight: 800;
  }
  .site-heading-lower {
    font-size: 5rem;
    font-weight: 100;
    line-height: 4rem;
  }
}

.page-section {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.section-heading {
  text-transform: uppercase;
  .section-heading-upper {
    display: block;
    font-size: 1rem;
    font-weight: 800;
  }
  .section-heading-lower {
    display: block;
    font-size: 3rem;
    font-weight: 100;
  }
}

.bg-faded {
  background-color: fade-out($white, 0.15);
}

.slide-right-leave {
  opacity: 1;
  transform: translateX(0);
}

.slide-right-leave-active {
  transition: opacity 0.5s ease-in;
  opacity: 0;
  animation: slide-out-right 0.5s ease-in forwards;
}

.slide-right-enter {
  opacity: 0;
}

.slide-right-enter-active {
  transition: opacity 1s ease-out;
  animation: slide-in-right 1s ease-out forwards;
}

.slide-left-leave {
  opacity: 1;
  transform: translateX(0);
}

.slide-left-leave-active {
  transition: opacity 0.5s ease-in;
  opacity: 0;
  animation: slide-out-left 0.5s ease-in forwards;
}

.slide-left-enter {
  opacity: 0;
}

.slide-left-enter-active {
  transition: opacity 1s ease-out;
  animation: slide-in-left 1s ease-out forwards;
}

@keyframes slide-out-left {
  0% {
    transform: translateX(0);
  }
  45% {
    transform: translateX(95px);
  }
  50% {
    transform: translateX(100px);
  }
  55% {
    transform: translateX(95px);
  }
  100% {
    transform: translateX(-100px);
  }
}

@keyframes slide-in-left {
  0% {
    transform: translateX(100px);
  }
  45% {
    transform: translateX(-95px);
  }
  50% {
    transform: translateX(-100px);
  }
  55% {
    transform: translateX(-95px);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-out-right {
  0% {
    transform: translateX(0);
  }
  45% {
    transform: translateX(-95px);
  }
  50% {
    transform: translateX(-100px);
  }
  55% {
    transform: translateX(-95px);
  }
  100% {
    transform: translateX(100px);
  }
}

@keyframes slide-in-right {
  0% {
    transform: translateX(-100px);
  }
  45% {
    transform: translateX(95px);
  }
  50% {
    transform: translateX(100px);
  }
  55% {
    transform: translateX(95px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
